import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Save } from "lucide-react";
import { toast } from "sonner";

export default function SettingsPage() {
  const [form, setForm] = useState({ name: "", nif: "", address: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/issuer`)
      .then(r => setForm(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/issuer`, form);
      toast.success("Datos del emisor actualizados");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error guardando");
    } finally { setSaving(false); }
  };

  if (loading) return <div className="flex items-center justify-center h-64 text-gray-400">Cargando...</div>;

  return (
    <div data-testid="settings-page">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl tracking-tight font-bold text-gray-900" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Configuracion</h2>
        <p className="text-sm text-gray-500 mt-1">Datos del emisor de facturas</p>
      </div>

      <div className="bg-white border border-gray-200 rounded-sm p-6 max-w-lg">
        <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-gray-500 mb-6">Datos fiscales del emisor</h3>
        <form onSubmit={handleSave} className="space-y-5" data-testid="issuer-form">
          <div>
            <Label className="text-sm font-semibold text-gray-900 mb-1 block">Nombre / Razón social</Label>
            <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Nombre o razon social" required className="rounded-sm" data-testid="issuer-name-input" />
          </div>
          <div>
            <Label className="text-sm font-semibold text-gray-900 mb-1 block">NIF / CIF</Label>
            <Input value={form.nif} onChange={e => setForm({...form, nif: e.target.value})} placeholder="B12345678" required className="rounded-sm" data-testid="issuer-nif-input" />
          </div>
          <div>
            <Label className="text-sm font-semibold text-gray-900 mb-1 block">Direccion fiscal</Label>
            <Input value={form.address} onChange={e => setForm({...form, address: e.target.value})} placeholder="Calle, numero, ciudad, CP" required className="rounded-sm" data-testid="issuer-address-input" />
          </div>
          <button
            type="submit"
            disabled={saving}
            className="bg-[#002FA7] text-white hover:bg-[#00227B] rounded-sm px-5 py-2 text-sm font-semibold transition-all duration-200 flex items-center gap-2 disabled:opacity-50"
            data-testid="save-issuer-button"
          >
            <Save className="w-4 h-4" /> {saving ? "Guardando..." : "Guardar datos"}
          </button>
        </form>
      </div>
    </div>
  );
}
